document.addEventListener("DOMContentLoaded", function () {
  function startCountdown(duration, display) {
    var timer = duration,
      hours,
      minutes,
      seconds;
    setInterval(function () {
      hours = parseInt(timer / 3600, 10);
      minutes = parseInt((timer % 3600) / 60, 10);
      seconds = parseInt(timer % 60, 10);

      hours = hours < 10 ? "0" + hours : hours;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;

      display.textContent = hours + ":" + minutes + ":" + seconds;

      if (--timer < 0) {
        timer = duration;
      }
    }, 1000);
  }

  var countdownTime = 5 * 60 * 60; // 5 hours in seconds
  var display = document.getElementById("countdown-timer");
  console.log(display);
  startCountdown(countdownTime, display);
});
